import showdown from 'showdown';

export function getMarkdownFromQuill(quillRef) {
	const html = quillRef.current.getSemanticHTML();
	const markdown = new showdown.Converter().makeMarkdown(html);
	return markdown;
}
